"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const theme_1 = require("@zapier/theme");
const LogoImage_1 = __importDefault(require("../LogoImage"));
const containerCss = core_1.css `
  & + & {
    margin-top: ${theme_1.Spacing.medium}px;
  }
`;
const listCss = core_1.css `
  list-style-type: none;
  margin: 0;
  margin-top: ${theme_1.Spacing.small}px;
  padding: 0;
`;
const divCss = core_1.css `
  display: block;
  width: 100%;
  border-radius: 10px;
  border: 2px solid transparent;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
`;
const linkCss = core_1.css `
  ${divCss}
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f8ff;
  }

  &:focus {
    border-color: ${theme_1.Colors.blue500};
  }
`;
const headingCss = core_1.css `
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
const logoCss = core_1.css `
  margin-right: ${theme_1.Spacing.small}px;
  flex: 0 1;
`;
const titleCss = core_1.css `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 0;
  margin: 0;
  padding: 0;
  text-align: left;
`;
const subtitleCss = core_1.css `
  margin-left: ${theme_1.Spacing.medium}px;
  white-space: nowrap;
  flex: 0 1;
`;
const ErrorGroup = ({ app, title, number, href, children, }) => {
    const headingContent = (common_utils_1.isolateComponent("div", { "aria-hidden": true, css: headingCss },
        app && (common_utils_1.isolateComponent("div", { css: logoCss },
            common_utils_1.isolateComponent(LogoImage_1.default, { app: app, backgroundType: "white", border: true, borderPadding: 5, borderRadius: 8, size: 20 }))),
        common_utils_1.isolateComponent("span", { css: titleCss },
            common_utils_1.isolateComponent(design_system_1.Text, { color: "black", type: "subtitle700" },
                number && `${number}. `,
                title)),
        href && (common_utils_1.isolateComponent("span", { css: subtitleCss },
            common_utils_1.isolateComponent(design_system_1.Text, { color: "blue500", fontWeight: 700, type: "altText900" }, "Go to step")))));
    const heading = href ? (common_utils_1.isolateComponent(design_system_1.Link, { "aria-label": `Step ${number}: ${title}. Click to open this step.`, css: linkCss, href: href }, headingContent)) : (common_utils_1.isolateComponent("div", { "aria-label": title, css: divCss }, headingContent));
    return (common_utils_1.isolateComponent("div", { css: containerCss },
        heading,
        common_utils_1.isolateComponent("ul", { "aria-label": `Errors in ${number ? `step ${number} of your Zap.` : `your Zap.`}`, css: listCss }, children)));
};
exports.default = ErrorGroup;
